import { Gameplay } from "appworks/model/gameplay/gameplay";
import { RequestBuilder } from "appworks/server/builders/request-builder";
import { SocketRequest } from "appworks/server/connectors/socket-connector";
import { Services } from "appworks/services/services";
import { gameiomModel } from "gameiom/model/gameiom-model";
import { SpinRequestPayload } from "slotworks/model/gameplay/requests/spin-request-payload";
import { SlotBetService } from "slotworks/services/bet/slot-bet-service";

export class SpinRequestBuilder implements RequestBuilder {
    public static force: string;

    public filter(request: any): boolean {
        return request instanceof SpinRequestPayload;
    }

    public build(gameplay: Gameplay, request: any): SocketRequest {
        let clearRecovery: boolean = false;
        let force: string | number[] = SpinRequestBuilder.force;

        if (force === "clearRecovery") {
            clearRecovery = true;
            force = null;
        }

        SpinRequestBuilder.force = null;

        const body = {
            publicState: {
                action: "spin",
                gameId: gameiomModel.gameId,
                betAmount: Services.get(SlotBetService).getCreditPerLine(),
                denom: Services.get(SlotBetService).getCreditSize(),
                winLines: Services.get(SlotBetService).getSelectedLines(),
                force
            }
        };

        if (body.publicState.force === null) {
            delete body.publicState.force;
        }

        if (clearRecovery) {
            ((body.publicState) as any).cleanState = true;
        }

        return new SocketRequest(body, gameiomModel.url);
    }
}
